import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
ChartJS.register(CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip,Legend);

const TotalCollection = () => {
  const [chartData, setChartData] = useState(null); // State to store fetched data
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    axios
      .get("/totalcollection.json")
      .then((response) => {
        const jsonData = response.data.data;

        // Prepare chart data
        const labels = jsonData.map((data) => data.time);
        const datasets = [
          {
            label: "Snooker 1",
            data: jsonData.map((data) => data.snooker1),
            borderColor: "#0A5B20", 
            backgroundColor: "#0A5B20",
            pointRadius: 4,
            tension: 0.4,
          },
          {
            label: "Snooker 2",
            data: jsonData.map((data) => data.snooker2),
            borderColor: "#119736", 
            backgroundColor: "#119736",
            pointRadius: 4,
            tension: 0.4,
          },
          {
            label: "Pool",
            data: jsonData.map((data) => data.pool),
            borderColor: "#42B862", 
            backgroundColor: "#42B862",
            pointRadius: 4,
            tension: 0.4,
          },
        ];

        setChartData({ labels, datasets });
        setLoading(false); // Set loading to false
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false); // loading to false even if there's an error
      });
  }, []);

  const options = {
    responsive: true,
    
    plugins: {
        legend: {
          position: "bottom",
        labels: {
            boxWidth: 12,
            boxHeight: 12,
        },
    },
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: "Time (HH:MM)",
        },
        border:{
          dash:[6,6],
          color:"#C6C6C6",
        }
    },
      y: {
        display:true,
        title: {
          display: true,
          text: "Total Collection (in currency)",
        },
        border:{
          dash:[6,6],
          color:"#C6C6C6",
        },
      },
    },
  };

  if (loading) {
    return <div className="text-center text-gray-700">Loading...</div>;
  }
  return (
    <div className="relative bg-white shadow-md rounded-2xl p-3 my-8 ">
      <h1 className="text-G800 text-xl lg:text-2xl p-3 mb-2 font-medium">Total collection Over time table</h1>
      <p className="text-gray-600 text-[12px] absolute bottom-5 font-medium left-7 xs:left-12 sm:left-1/4 xl:left-[370px]">Table</p>
      {chartData ? (
        <Line data={chartData} options={options}  height={100}/>
      ) : (
        <div>Error loading chart data</div>
      )}
    </div>
  );
};

export default TotalCollection;
